import PDFIcon from "../../Images/pdfIcon.png";

const ClosureOfTradingWindow = () => {
  const documents = [
    {
      title: "Closure of Trading Window - September 2025",
      buttonLabel: "View Document",
      fileName: "Intimation-to-SE-for-closure-of-trading-window.pdf",
    },
    {
      title: "Closure of Trading Window - March 2026",
      buttonLabel: "View Document",
      fileName: "Intimation to SE for closure of trading window (1).pdf",
    },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
              <h2 className="site-title">Closure of <span>Trading Window</span></h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.map((doc, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item p-3">
                <img src={PDFIcon} alt="pdf icon" />
                <div className="team-content">
                  <div className="team-bio">
                    <h5>{doc.title}</h5>
                    <a
                      className="theme-btn mt-2"
                      href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.buttonLabel}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClosureOfTradingWindow;
